

import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Form, Input } from "antd";
import commonRules from "components/Pages/User/common/rules";
import Dynamic, { type ExposeDynamicProps } from "@/components/App/Dynamic";
import useNextTick from "@/hooks/useNextTick";
import { axiosThrottle } from "@/utils/method";
import { waitRes } from "@/utils/axios";
import { get_faResult, get_getFaCheckItem } from "@/api/uaapi/user";
import NoEmail from "@/components/Xt/NoEmail";
import useAsyncEffect from "@/hooks/useAsyncEffect";
import { openLivehelp100Support } from "@/utils/livehelp100";
export interface FaItemProps {
  priority: number;
  msgType?: string | number;
  validateItemType: number;
}
export interface FaCheckProps {
  faCheckId: string;
  email?: string;
  mobile?: string;
  dynamicCodeType?: string;
  faItems: FaItemProps[];
  /** 1 任选一项；2 全部必验；3 谷歌必验且手机/邮箱任选其一 */
  faType?: number;
  isAnswer?: number,
  countryCode?: string;
  faResultId?: string;
  faResetAuthId?: string;
}
type CopyFaCheckProps = FaCheckProps
export interface FaResultProps {
  faResultId: string;
}
interface SafeVerifyProps extends BaseCompProps {
  attr?: any;
  /**get_getFaCheckItem返回值 */
  faCheckData?: FaCheckProps;
  /**按钮文案*/
  btnText?: string;
  /**业务类型 */
  faBizType: number;
  /**是否显示安全项不可用按钮 */
  showLink?: boolean;
  /** Confirm 按钮上方插槽（如人机验证） */
  beforeConfirm?: React.ReactNode;
  /**dynamic code码 */
  dynamicCodeType?: string;
  verifyForm?: ObjAny;
  mt?: number;
  /** 首次绑定且 faItems 为空时仍展示确认，只用 faCheckId 换 faResultId */
  allowEmptySubmit?: boolean;
  handleSuccessFn?(data: FaResultProps, formData: FormDataType): void;
}

const { useTranslation } = Hooks;
const { useForm } = Form;
const initFormData = {
  emailCode: "",
  mobileCode: "",
  googleCode: "",
};
type FormDataType = typeof initFormData & ObjAny;
const defaultFaCheckData = {};
const SafeVerify: React.FC<SafeVerifyProps> = ({
  className,
  faCheckData = defaultFaCheckData as FaCheckProps,
  btnText = "",
  faBizType,
  showLink = true,
  beforeConfirm,
  dynamicCodeType,
  verifyForm,
  mt,
  allowEmptySubmit = false,
  handleSuccessFn,
}) => {
  const t = useTranslation();
  const nextTick = useNextTick();
  const appCodeDynamicRef = useRef({} as ExposeDynamicProps);
  //const {isLogin} = store.user;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initFormData } as FormDataType);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailFa, setEmailFa] = useState(false);
  const [mobileFa, setMobileFa] = useState(false);
  const [googleFa, setGoogleFa] = useState(false);
  const [faItems, setFaItems] = useState<FaItemProps[]>([]);
  const [faType, setFaType] = useState<number>();
  const [channel, setChannel] = useState<"email" | "mobile">("email");
  const [showmodal, setShowmodal] = useState(false);
  const [noEmailVisible, setNoEmailVisible] = useState(false);
  const [mobileMsgType, setMobileMsgType] = useState(0);
  const [backUrl] = useState(window.location.origin + window.location.pathname);
  const [copyFaCheckData, setCopyFaCheckData] = useState({} as CopyFaCheckProps);
  const [noEmailClickNumber, setNoEmailClickNumber] = useState(0);
  /**useEffect */
  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);

  useAsyncEffect(async () => {
    let res = {} as FaCheckProps;
    if (faCheckData.faItems) {
      res = faCheckData;
    } else {
      const { data, err } = await waitRes(get_getFaCheckItem, { params: { faBizType }, errorPop: true });
      if (!err) {
        res = data;
      }
    }
    if (!res.dynamicCodeType) res.dynamicCodeType = dynamicCodeType;
    const nextFaType = Number(res.faType);
    setFaItems(res.faItems || []);
    setFaType(Number.isNaN(nextFaType) ? undefined : nextFaType);
    const emailFa = res.faItems?.some((faitem) => faitem.validateItemType == 0);
    const mobileFa = res.faItems?.some((faitem) => faitem.validateItemType == 1);
    const googleFa = res.faItems?.some((faitem) => faitem.validateItemType == 2);
    setEmailFa(emailFa);
    setMobileFa(mobileFa);
    setGoogleFa(googleFa);
    if (nextFaType === 3 && emailFa && mobileFa) {
      setChannel("email");
    }
    setEmail(res.email || "");
    setMobile(res.mobile || "");
    setCopyFaCheckData({ ...res });
  }, [faCheckData]);

  const eitherChannel = faType === 3 && emailFa && mobileFa;
  const showEmailCode = emailFa && (!eitherChannel || channel === "email");
  const showMobileCode = mobileFa && (!eitherChannel || channel === "mobile");
  const emailItem = faItems.find((item) => item.validateItemType == 0);
  const mobileItem = faItems.find((item) => item.validateItemType == 1);

  const resolveCodeType = (item?: FaItemProps) => {
    const raw = item?.msgType;
    if (raw == null || raw === "") return copyFaCheckData.dynamicCodeType;
    const text = String(raw);
    return /^\d+$/.test(text) ? `USER_${text}` : text;
  };

  const maskedEmail = email.includes("*") ? email : email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3");
  const maskedMobile = !mobile
    ? ""
    : mobile.includes("*")
      ? mobile
      : mobile.length > 7
        ? mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
        : mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2");

  const selectChannel = (next: "email" | "mobile") => {
    setChannel(next);
    const nextForm = {
      ...formData,
      emailCode: next === "email" ? formData.emailCode : "",
      mobileCode: next === "mobile" ? formData.mobileCode : "",
    };
    setFormData(nextForm);
    formIns.setFieldsValue(nextForm);
  };

  /**useMemo */
  const disabledForm = useMemo(() => {
    const mapCode = {
      emailCode: showEmailCode,
      mobileCode: showMobileCode,
      googleCode: googleFa,
    };

    const codeFlag = Object.keys(formData)
      .filter((k) => !!mapCode[k])
      .some((k1) => formData[k1] == "");
    const formFlag = verifyForm ? Object.keys(verifyForm).some(key => !verifyForm[key]) : false;
    return codeFlag || formFlag;
  }, [formData, showEmailCode, showMobileCode, googleFa, verifyForm]);
  /**method */
  const valuesChange = (changedValues: FormDataType, allValues: FormDataType) => {
    const data = { ...formData, ...changedValues };
    setFormData(data);
  };

  const noEmailChange = () => {
    if (noEmailClickNumber) {
      setNoEmailVisible(true);
    }
    setNoEmailClickNumber(1);
  };

  const hasOldFactor = emailFa || mobileFa || googleFa;
  const showConfirm = hasOldFactor || (allowEmptySubmit && !!copyFaCheckData.faCheckId);

  const submitForm = axiosThrottle(async (unlock) => {
    if (!copyFaCheckData.faCheckId) {
      unlock();
      return;
    }
    const params: ObjAny = {
      faBizType,
      faCheckId: copyFaCheckData.faCheckId,
    };
    if (showEmailCode) params.emailCode = formData.emailCode;
    if (showMobileCode) params.mobileCode = formData.mobileCode;
    if (googleFa) params.googleCode = formData.googleCode;
    const { data, err } = await waitRes(get_faResult, {
      errorPop: true,
      params,
    });
    if (err) return;
    handleSuccessFn && handleSuccessFn(data as FaResultProps, formData);
    formIns.setFieldsValue({ ...initFormData })
    setFormData({ ...initFormData })
    unlock();
  });
  return (
    <div className={cx(className, styles["safe-verify-ctn"], styles["account_container"])}>
      <Form name="safeVerifyForm" initialValues={formData} form={formIns} onValuesChange={valuesChange} layout="vertical">
        {eitherChannel && (
          <div className={styles.channelSwitch} role="tablist">
            <button
              type="button"
              className={cx(styles.channelBtn, channel === "email" && styles.channelBtnActive)}
              onClick={() => selectChannel("email")}
            >
              {t("account.emailVerifyOption")}
            </button>
            <button
              type="button"
              className={cx(styles.channelBtn, channel === "mobile" && styles.channelBtnActive)}
              onClick={() => selectChannel("mobile")}
            >
              {t("account.phoneVerifyOption")}
            </button>
          </div>
        )}
        {showEmailCode && (
          <Form.Item name="emailCode" label={t("google.gmail", { email: maskedEmail })} rules={commonRules.emailCode}>
            <Input
              maxLength={6}
              allowClear
              className={styles["common_form_input"]}
              autoComplete="off"
              suffix={
                <div className={styles["forget_password"]}>
                  <Dynamic
                    FaValidTypeDict={'EMAIL'}
                    faCheckId={copyFaCheckData.faCheckId}
                    msgType={2}
                    codeType={resolveCodeType(emailItem)} noEmailChange={noEmailChange} />
                </div>
              }
            />
          </Form.Item>
        )}
        {email && noEmailVisible && (
          <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setShowmodal(true)}>
            {t("google.noEmail")}
          </div>
        )}
        {showMobileCode && (
          <Form.Item name="mobileCode" label={t("google.mobile", { mobile: maskedMobile })} rules={commonRules.mobileCode}>
            <Input
              maxLength={6}
              allowClear
              className={styles["common_form_input"]}
              autoComplete="new-text"
              suffix={
                <div className={styles["forget_password"]}>
                  <Dynamic
                    ref={appCodeDynamicRef}
                    FaValidTypeDict={'MOBILE'}
                    msgType={mobileMsgType}
                    faCheckId={copyFaCheckData.faCheckId}
                    codeType={resolveCodeType(mobileItem)}
                    onClick={() => {
                      setMobileMsgType(0);
                    }}
                  />
                </div>
              }
            />
          </Form.Item>
        )}

        {/* 语音验证码功能已注释 */}
        {/* {mobileFa && (
          <div className={cx(styles["voice"], !mt && styles["mt12"])}>
            <span onClick={() => { setMobileMsgType(1); nextTick(() => appCodeDynamicRef.current.handleClick(true)); }}>
              {t("2fa.voiceCode")}
            </span>
          </div>
        )} */}
        {googleFa && (
          <Form.Item name="googleCode" label={t("account.AuthenticationCode")} rules={commonRules.googleCode}>
            <Input maxLength={6} allowClear className={styles["common_form_input"]} autoComplete="new-text" />
          </Form.Item>
        )}
      </Form>

      {!!faItems?.length && showLink && (
        <>
          {/* 原：Next Link → /accounts/user/reset-verification */}
          {/* <Link href={{ pathname: "/accounts/user/reset-verification", search: `faCheckId=${copyFaCheckData.faCheckId}&backUrl=${backUrl}` }}>
            <div className={styles["text2"]}>{t("google.security")}</div>
          </Link> */}
          <div
            className={styles["text2"]}
            role="button"
            tabIndex={0}
            onClick={() => openLivehelp100Support()}
            onKeyDown={(e) => e.key === "Enter" && openLivehelp100Support()}
          >
            {t("google.security")}
          </div>
        </>
      )}
      {beforeConfirm}
      {showConfirm && (
        <div className={cx(styles["base-btn"], disabledForm && styles["disabledBtn"])} onClick={submitForm}>
          {btnText || t("account.confirm")}
        </div>
      )}
      <NoEmail open={showmodal} changeOpen={() => setShowmodal(false)} email={copyFaCheckData.email} />
    </div>
  );
};
export default observer(SafeVerify);
